__turbopack_context__.v({
  "ProductList": "ProductList-module__8IA6ka__ProductList",
  "loading": "ProductList-module__8IA6ka__loading",
  "pulse": "ProductList-module__8IA6ka__pulse",
});
